<template>
  <div>
    <div>
      <SelectableListBase
        titleAdd="SELECIONAR PRODUTOS:"
        titleSelected="PRODUTOS SELECIONADOS:"
        :items="availableProdutos"
        :itemsSelected="form.mixProdutos"
        itemKey="id"
        :columns="[
          { key: 'id', label: 'ID' },
          { key: 'desc', label: 'Produto' },
        ]"
        :loadItems="searchItems"
        :itemTransform="
          (item) => ({
            id: item.id,
            idExibicao: item.idExibicao,
            desc: item.descComp,
          })
        "
        :selectCallback="addProduto"
        :deselectCallback="removeProduto"
        :disableCondition="
          (item, selected) => selected.some((s) => s.id === item.id)
        "
        :disableAddCondition="(item) => item.disabled"
      />
    </div>
  </div>
</template>

<script>
import { get } from "@/helpers/apiRequest";
import SelectableListBase from "../../../../components/selecoes/SelectableListBase.vue";

import _remove from "lodash/remove";

const findIndexRestricao = (tipo, form) => {
  return form.restricoes.findIndex((restricao) => restricao.tipo === tipo);
};

export default {
  name: "MixProdutos",
  props: {
    form: { type: Object, required: true },
  },
  components: { SelectableListBase },
  data() {
    return {
      indexRestricao: findIndexRestricao("cliente", this.form),
      availableProdutos: [],
    };
  },
  methods: {
    async searchItems(term = "", take = 36) {
      try {
        const json = await get(
          `/admin/produtos-paginados?termo=${encodeURIComponent(
            term
          )}&take=${take}`
        );
        this.availableProdutos = json.itens || [];
      } catch (err) {
        console.error("Erro ao buscar produtos:", err);
        this.availableProdutos = [];
      }
    },
    addProduto(novoProduto) {
      const existe = this.form.mixProdutos.some(
        (produto) => produto.id === novoProduto.id
      );
      if (!existe) {
        this.form.mixProdutos.push(novoProduto);
      } else {
        console.warn(
          `Tentativa de adicionar produto duplicado: ID ${novoProduto.id}`
        );
      }
    },
    removeProduto(idProduto) {
      let produtosAtuais = [...this.form.mixProdutos];

      _remove(produtosAtuais, (produto) => +produto.id === +idProduto);

      this.form.mixProdutos = produtosAtuais;
    },

    created() {
      this.searchItems();
    },
  },
};
</script>
